<template>
  <el-tabs v-model="selectedTab">
    <el-tab-pane
      name="commonExport"
      label="表格輸出"
      :lazy="true"
    >
      <page-export
        :key="selectedTab"
        :useUrl="this.useUrl"
        :mode="selectedTab"
      />
    </el-tab-pane>

    <el-tab-pane
      v-if="this.thsrRole"
      name="rainExport"
      label="雨量輸出"
      :lazy="true"
    >
      <page-export
        :key="selectedTab"
        :useUrl="this.useUrl"
        :mode="selectedTab"
      />
    </el-tab-pane>

    <el-tab-pane
      v-if="this.thsrRole"
      name="TMExport"
      label="TM 輸出"
      :lazy="true"
    >
      <page-export
        :key="selectedTab"
        :useUrl="this.useUrl"
        :mode="selectedTab"
      />
    </el-tab-pane>
    
    <el-tab-pane
      v-if="this.thsrRole"
      name="ELPExport"
      label="ELP 輸出"
      :lazy="true"
    >
      <page-export
        :key="selectedTab"
        :useUrl="this.useUrl"
        :mode="selectedTab"
      />
    </el-tab-pane>

    <el-tab-pane
      v-if="this.enableReportExport"
      name="reportExport"
      label="報表輸出"
      :lazy="true"
    >
      <page-report />
    </el-tab-pane>
    <el-tab-pane
      v-if="this.kmrtRole || this.export-instrument"
      name="instrumentList"
      label="儀器清單"
      :lazy="true"
    >
      <page-instrument-list />
    </el-tab-pane>
    <el-tab-pane
      v-if="this.kmrtRole || this.enableAlertsReportExport"
      name="AlertReport"
      label="黃單/紅單輸出"
      :lazy="true"
    >
      <page-alert-report />
    </el-tab-pane>
    <el-tab-pane
      v-if="this.thsrRole && this.declRole"
      name="AutoReport"
      label="週報圖表輸出"
      :lazy="true"
    >
      <page-auto-report />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { clientVersion } from '../constants/env';
export default {
  components: {
    PageExport: () => import('@/components/Export'),
    PageReport: () => import('@/views/Report'),
    PageInstrumentList: () => import('@/components/export/instrumentList'),
    PageAlertReport: () => import('@/components/export/AlertReport'),
    PageAutoReport: () => import('@/components/report/autoReportComponent'),
  },
  props: {
    useUrl: {
      type: Boolean,
      default: false,
    },
  },
  computed:{
    allowedTab() {
      return this.$store.getters['project/selectedProject'].allowed_sidebar;
    },
    enableReportExport() {
      console.log('enableReportExport');
      const allowedTab = this.allowedTab;
      if([null,undefined].includes(allowedTab) || allowedTab.length == 0){
        console.log('get no allowedTab');
        return false;
      }
      console.log(allowedTab.includes('ReportExport'));
      return allowedTab.includes('ReportExport');
    },
    enableInstrumentListExport() {
      console.log('enableInstrumentListExport');
      const allowedTab = this.allowedTab;
      if([null,undefined].includes(allowedTab) || allowedTab.length == 0){
        console.log('get no allowedTab');
        return false;
      }
      console.log(allowedTab.includes('export-instrument'));
      return allowedTab.includes('export-instrument');
    },
    enableAlertsReportExport() {
      console.log('enableAlertsReportExport');
      const allowedTab = this.allowedTab;
      if([null,undefined].includes(allowedTab) || allowedTab.length == 0){
        console.log('get no allowedTab');
        return false;
      }
      console.log(allowedTab.includes('export-alertsreport'));
      return allowedTab.includes('export-alertsreport');
    },
    kmrtRole() {
      return clientVersion === 'test' || clientVersion === 'kmrt';
    },
    thsrRole() {
      return clientVersion === 'test' || clientVersion === 'thsr-main';
    },
    declRole() {
      return this.$store.getters['user/details'].roles === 'decl' || this.$store.getters['user/details'].roles === 'admin';
    },
  },
  data(){
    return {
      selectedTab: 'commonExport',
    };
  },
};
</script>
